// src/components/GeometricDivider.jsx

import React from 'react';
import './GeometricDivider.css';

const GeometricDivider = ({ className = '', bin1 = '01011001', bin2 = '10100110' }) => {
  return (
    <div className={`geometric-divider ${className}`.trim()} aria-hidden="true">
      <div className="divider-container">
        <div className="divider-line" />
        <div className="digital-line" />

        <div className="binary binary-1">{bin1}</div>
        <div className="binary binary-2">{bin2}</div>

        <div className="dots-grid">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="dot" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GeometricDivider;
